// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1inK7","productName":"Table_productName__1DmY5"};